import { arabToRoman } from 'roman-numbers';
import arabToLetter from 'number-to-letter';

const arabicToRoman = arabToRoman;

const arabicToLetter = (number) => arabToLetter(number - 1);

const arabicToArabicEven = (number) => 2 * number;

const arabicToArabicOdd = (number) => (2 * number) - 1;

export {
    arabicToRoman,
    arabicToLetter,
    arabicToArabicEven,
    arabicToArabicOdd,
};
